export default function initTrackingForChristmasOffersSection() {
  const section = document.querySelector('[data-test-id="christmasOffersSection"]');

  if (!section) {
    return;
  }

  const track = (element, elementValue) => {
    App.track.event('location_page_interaction', {
      section: 'christmas_offers',
      element,
      element_value: elementValue,
      interaction: 'click',
    });
  };

  section.querySelectorAll('.lp-christmas-offers__card').forEach(card => {
    card.addEventListener('click', (event) => {
      const roomId = card.dataset.trackValue;

      if (event.target.closest('.lp-christmas-offers__card-cta')) {
        track('see_full_package_cta', roomId);
        return;
      }

      track('room', roomId);
    });
  });

  section.querySelectorAll('.c-box-carousel-arrow').forEach(arrow => {
    arrow.addEventListener('click', () => {
      track('slider_arrow', arrow.classList.contains('c-box-carousel-arrow--left') ? 'left' : 'right');
    });
  });
}
